import React, { useEffect, useState } from "react";
import Text from "../../images/text_icon.svg";
import Amount from "../../images/amount_icon.svg";
import Brought from "../../images/amount.svg";
import { FormControlLabel, Button, Dialog, DialogContent } from "@mui/material";
import { FormControl, InputLabel, RadioGroup, Radio } from "@mui/material";
import { MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { updateTransaction } from "./transactionSlice";
import Repo from "../../Repository/Repo";
import { ClipLoader } from "react-spinners";

function UpdateTransaction({ row, onClose, status, idx, onSuccess }) {
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.daybookCat);
  const [loading, setLoading] = useState(false);
  const [amountRadio, setAmountRadio] = useState(
    row.credit ? "incoming" : "outgoing"
  );
  const [broughtForwardRadio, setBroughtForwardRadio] = useState("add");

  const [state, setState] = useState({
    nameNumber: row.nameNumber,
    broughtForward: row.broughtForward || "",
    amount: row.credit != "0" ? row.credit : row.debit,
    date: "",
    category: row.category,
  });

  useEffect(() => {
    let date = row.date.split("-");
    let Year = parseInt(date[2]);
    let Month = parseInt(date[1]);
    let Day = parseInt(date[0]);
    setState((prev) => ({ ...prev, date: `${Year}-${Month}-${Day}` }));
  }, []);

  const handleUpdate = async () => {
    try {
      if (status) {
        let newDate = state.date.split("-");
        let year = parseInt(newDate[0]);
        let month = parseInt(newDate[1]); //
        let day = parseInt(newDate[2]);
        let finalDate = `${day}-${month}-${year}`;
        let credit = 0;
        let debit = 0;
        if (amountRadio == "outgoing") {
          debit = state.amount;
        } else {
          credit = state.amount;
        }
        setLoading(true);
        let { data } = await Repo.datebook({
          request: {
            method: "updateDatebookTransaction",
            data: {
              _id: row._id,
              nameNumber: state.nameNumber,
              broughtForward: state.broughtForward,
              date: finalDate,
              category: state.category,
              credit: credit,
              debit: debit,
            },
          },
        });
        setLoading(false);
        onSuccess();
      } else {
        let record = {
          date: state.date,
          nameNumber: state.nameNumber,
          broughtForward: state.broughtForward,
        };
        if (amountRadio == "outgoing") {
          record.credit = 0;
          record.debit = state.amount;
        } else {
          record.credit = state.amount;
          record.debit = 0;
        }
        dispatch(updateTransaction({ record, idx }));
        onClose();
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleAmountRadio = (e) => {
    setAmountRadio(e.target.value);
  };
  const handleBroughtForwardRadio = (e) => {
    setBroughtForwardRadio(e.target.value);
  };

  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="sm">
      <DialogContent>
        <Stack spacing={1}>
          {!state.nameNumber && (
            <div className="flex-sec">
              <div className="right-sec">
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel>Select Category</InputLabel>
                  <Select
                    id="outlined-basic"
                    label="Select Category"
                    variant="outlined"
                    name="category"
                    value={state.category || ""}
                    onChange={handleInput}
                  >
                    <MenuItem value="">
                      <Typography sx={{ fontStyle: "italic" }}>
                        Select Category
                      </Typography>
                    </MenuItem>
                    {categories.map((item, i) => {
                      return (
                        <MenuItem key={i} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            </div>
          )}
          {!state.category && (
            <div className="flex-sec">
              <div className="text-ico">
                <img src={Text} alt="text" />
              </div>
              <TextField
                className="detail-txt"
                id="outlined-basic"
                label="Detail"
                variant="outlined"
                name="nameNumber"
                value={state.nameNumber}
                onChange={handleInput}
              />
            </div>
          )}
          <div className="flex-sec">
            <div className="text-ico">
              <img src={Amount} alt="Amount" className="hide-xs" />
            </div>
            <TextField
              className="detail-txt"
              name="amount"
              label="Amount"
              variant="outlined"
              type="number"
              value={state.amount}
              onChange={handleInput}
            />
          </div>
          <div className="flex-sec">
            <div className="right-sec">
              <RadioGroup className="radio-adj" value={amountRadio}>
                <div
                  className={`radio-border ${
                    amountRadio === "outgoing" && "border-green"
                  }`}
                >
                  <FormControlLabel
                    value="outgoing"
                    control={<Radio className="green" />}
                    onChange={handleAmountRadio}
                    label="Outgoing"
                  />
                </div>
                <div
                  className={`radio-border ${
                    amountRadio === "incoming" && "border-green"
                  }`}
                >
                  <FormControlLabel
                    value="incoming"
                    control={<Radio className="green" />}
                    onChange={handleAmountRadio}
                    label="Incoming"
                  />
                </div>
              </RadioGroup>
            </div>
          </div>
          {/* <div className="flex-sec">
            <div className="text-ico">
              <img src={Brought} alt="Amount" className="hide-xs" />
            </div>
            <TextField
              className="detail-txt"
              id="outlined-basic"
              type="number"
              label="Brought forward"
              variant="outlined"
              name="broughtForward"
              value={state.broughtForward}
              onChange={handleInput}
            />
          </div>
          <div className="flex-sec">
            <div className="right-sec">
              <RadioGroup
                className="radio-adj"
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="add"
                name="radio-buttons-group"
              >
                <div
                  className={`radio-border ${
                    broughtForwardRadio === "add" && "border-green"
                  }`}
                >
                  <FormControlLabel
                    value="add"
                    control={<Radio className="green" />}
                    onChange={handleBroughtForwardRadio}
                    label="Add"
                  />
                </div>
                <div
                  className={`radio-border ${
                    broughtForwardRadio === "subtract" && "border-green"
                  }`}
                >
                  <FormControlLabel
                    value="subtract"
                    control={<Radio className="green" />}
                    onChange={handleBroughtForwardRadio}
                    label="Subtract"
                  />
                </div>
              </RadioGroup>
            </div>
          </div> */}
          <div className="flex-sec">
            <div className="right-sec radio-adj">
              <Typography
                className="date-label"
                sx={{ fontSize: { md: "16px", xs: "10px" } }}
              >
                Transaction date:
              </Typography>
              <div>
                <TextField
                  id="date"
                  size="small"
                  // className={classes.datePick}
                  type="date"
                  name="date"
                  onChange={handleInput}
                  value={state.date}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
          </div>
          {loading && (
            <Stack
              mt="20px"
              alignItems="center"
              width="100%"
              justifyContent="center"
            >
              <ClipLoader loading={true} color="#4eaf51" size={20} />
            </Stack>
          )}
          {!loading && (
            <Stack
              mt="20px"
              direction="row"
              width="100%"
              justifyContent="space-between"
            >
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  background: "rgb(138, 138, 138) !important",
                }}
                onClick={toggle}
              >
                Cancel
              </Button>
              <Button
                sx={{ textTransform: "none" }}
                variant="contained"
                onClick={handleUpdate}
              >
                Update Transaction
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default UpdateTransaction;
